/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/346-ungroup': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M6 7.25c0 .412-.338.75-.75.75h-1.5A.752.752 0 013 7.25v-1.5c0-.412.337-.75.75-.75h1.5c.412 0 .75.338.75.75v1.5zM11 7.25c0 .412-.338.75-.75.75h-1.5A.753.753 0 018 7.25v-1.5c0-.412.338-.75.75-.75h1.5c.412 0 .75.338.75.75v1.5zM6 12.25c0 .412-.338.75-.75.75h-1.5a.752.752 0 01-.75-.75v-1.5c0-.412.337-.75.75-.75h1.5c.412 0 .75.338.75.75v1.5zM11 12.25c0 .412-.338.75-.75.75h-1.5a.753.753 0 01-.75-.75v-1.5c0-.412.338-.75.75-.75h1.5c.412 0 .75.338.75.75v1.5zM14.251 2.5L16 .751V0h-.751L13.5 1.749 11.751 0H11v.751L12.749 2.5 11 4.249V5h.751L13.5 3.251 15.249 5H16v-.751zM0 12h1v2H0v-2zM0 9h1v2H0V9zM13 7h1v2h-1V7zM13 13h1v2h-1v-2zM13 10h1v2h-1v-2zM0 6h1v2H0V6zM0 3h1v2H0V3zM8 2h2v1H8V2zM5 2h2v1H5V2zM2 2h2v1H2V2zM7 15h2v1H7v-1zM10 15h2v1h-2v-1zM4 15h2v1H4v-1zM1 15h2v1H1v-1z"/>'
  }
})
